import script from "./AssistentsChat.vue?vue&type=script&setup=true&lang=js"
export * from "./AssistentsChat.vue?vue&type=script&setup=true&lang=js"

import "./AssistentsChat.vue?vue&type=style&index=0&id=df6f9fe0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df6f9fe0"]])

export default __exports__